




























import {Vue, Component, Prop, Model} from 'vue-property-decorator';
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import FileService from "@/services/FileService";
import Workspaces from "@/state/Workspaces";
import {PropType} from "vue";
import ViewedDocumentModal from "@/components/util/ViewedDocumentModal.vue";
import { namespace } from "vuex-class";
import Application from "@/state/Application";

const ViewedDocumentModule = namespace('ViewedDocument');

@Component
export default class SingleFileHolder extends Vue {

  @ViewedDocumentModule.Mutation
  private setViewedDocument!: (file: FileMetaDTO | null) => void

  @ViewedDocumentModule.Mutation
  private setResolveOpenViewedDocumentModal!: (value: boolean) => void

  @ViewedDocumentModule.State
  private viewedDocument!: FileMetaDTO | null

  @ViewedDocumentModule.State
  private resolveOpenViewedDocumentModal!: boolean

  @Model('change', { type: [Object, FileMetaDTO, null] as PropType<FileMetaDTO | null> })
  readonly fileValue!: FileMetaDTO | null;

  @Prop({ default: false })
  confirmationRequired!: boolean;

  @Prop()
  placeholder!: string;

  @Prop({default: (file: FileMetaDTO) => Vue.prototype.$void})
  onFileUploaded!: (file: FileMetaDTO) => void;

  @Prop()
  onFileDeleted!: () => void;

  @Prop({default: true})
  showFileName!: boolean;

  @Prop({default: true})
  deletable!: boolean;

  @Prop({default: false})
  required!: boolean;

  @Prop({default: true})
  isValidFile!: boolean;

  private uploading = false;

  async uploadSelectedFile(file: File): Promise<void> {
    if (this.uploading) return;
    this.uploading = true;
    this.$emit('uploading', true);
    try {
      const uploadedFile = await this.uploadToServer(file);
      if ((this as any)._isDestroyed) return;
      this.setViewedDocument(uploadedFile);
      if (this.confirmationRequired && this.resolveOpenViewedDocumentModal) {
        this.$modal.show(
          ViewedDocumentModal,
          {
            placeholder: this.placeholder || "Upload file",
            repeatUploadFile: () => this.uploadFile(),
            saveUploadFile: () => this.saveUploadFile(this.viewedDocument!)
          },
          {},
          {
            'before-open': () => Application.startLoading(),
            'opened': () => Application.stopLoading(),
            'before-close': () => this.setResolveOpenViewedDocumentModal(true),
          }
        );
      }
      if (!this.confirmationRequired) this.saveUploadFile(uploadedFile);
    } catch (error) {
      if ((this as any)._isDestroyed) return;
      if (this.$listeners['upload-error']) this.$emit('upload-error', error);
      else throw error;
    } finally {
      this.uploading = false;
      this.$emit('uploading', false);
    }
  }

  uploadFile(): void {
    if (this.uploading) return;
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.addEventListener('change', async () => {
      if (fileInput.files && fileInput.files[0]) {
        await this.uploadSelectedFile(fileInput.files[0]);
      }
    });
    fileInput.click();
  }

  saveUploadFile(uploadedFile: FileMetaDTO) {
    this.$emit('change', uploadedFile);
    if (this.onFileUploaded) this.onFileUploaded(uploadedFile);
  }

  async uploadToServer(file: File): Promise<FileMetaDTO> {
    return FileService.uploadFile(file, Workspaces.getCurrent ? Workspaces.getCurrent.userId : null, null).then(
        response => {
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(error);
        }
    );
  }

  deleteFile(): void {
    this.$emit('change', null);
    this.setViewedDocument(null);
    if (this.onFileDeleted) this.onFileDeleted();
  }

}
